import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import ProtectedLayout from "../layouts/ProtectedLayout";
import PublicLayout from "../layouts/PublicLayout";
import DefaultLayout from "../layouts/DefaultLayout";
import BuilderLayout from "src/layouts/BuilderLayout";

//:- Pages to be rendered on specific endpoints
import AnalyticsLogin from "../pages/LoginPage";
import DashboardPage from "../pages/DashboardPage";
import ReportPage from "src/pages/ReportPage";
import DashboardBuilder from "src/pages/DashboardBuilder";
import UserManagement from "src/pages/UserManagement";

//:- Admin portal (DEV-3952) — lazy chunk, kept out of the analytics bundle
const PortalLogin = lazy(() => import("src/pages/portal/PortalLogin"));
const PortalLayout = lazy(() => import("src/layouts/PortalLayout"));
const PortalUsersPage = lazy(() => import("src/pages/portal/UsersPage"));
const PortalProgramsPage = lazy(() => import("src/pages/portal/ProgramsPage"));
const PortalProductsPage = lazy(() => import("src/pages/portal/ProductsPage"));
const PortalTiersPage = lazy(() => import("src/pages/portal/TiersPage"));

export default function AnalyticsRoutes() {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          {/* All Protected Routes will be placed in this group */}
          <Route element={<ProtectedLayout />}>
            <Route path="/reports/:report_name" element={<ReportPage />} />
            <Route
              path="/dashboards/:dashboard_name?"
              element={<DashboardPage />}
            />
            <Route path="/user-management" element={<UserManagement />} />
          </Route>

          {/* All Protected Buider Routes will be placed in this group */}
          <Route element={<BuilderLayout />}>
            <Route
              path="/builder/:dashboard_name?"
              element={<DashboardBuilder />}
            />
          </Route>

          <Route element={<PublicLayout />}>
            <Route path="/users/sign_in" element={<AnalyticsLogin />} />
          </Route>

          {/* Admin portal (DEV-3952) — own login + role-gated shell */}
          <Route path="/portal/login" element={<PortalLogin />} />
          <Route element={<PortalLayout />}>
            <Route
              path="/portal"
              element={<Navigate to="/portal/users" replace />}
            />
            <Route path="/portal/users" element={<PortalUsersPage />} />
            <Route path="/portal/programs" element={<PortalProgramsPage />} />
            <Route path="/portal/products" element={<PortalProductsPage />} />
            <Route path="/portal/tiers" element={<PortalTiersPage />} />
          </Route>

          <Route path="/" element={<DefaultLayout />} />
          <Route path="*" element={<DefaultLayout />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
